import React, { Component } from 'react';
import DateTimeUtils from 'share/utils/Izenda.DateTimeUtils';
import commonDataStore from 'logic/Izenda.ReportDesignerCommonDataStore';
import {
  FIELD_FUNCTION_MODE,
  FUNCTION
} from 'logic/data/Izenda.ReportPartFieldConstants';
import PropertiesEditorModel from 'logic/models/Izenda.PropertiesEditor';
import { DATA_TYPES } from 'logic/data/Izenda.ReportDesignerConstants';
import reportPartUtils from 'share/utils/Izenda.ReportPartUtils';

const {
  isNil,
  getOr,
  concat,
  has,
  clone,
  reduce,
  isObject,
  assign,
  get,
  isFunction,
  tail,
  isString,
  isUndefined,
  flow, map, find, groupBy,
} = require('lodash/fp');

const MAIN_MENU_ITEM = 'MAIN_MENU_ITEM';
const SUB_MENU_ITEM = 'SUB_MENU_ITEM';
const SUB_MENU_ITEM_FUNCTION = 'SUB_MENU_ITEM_FUNCTION';
const SUB_MENU_ITEM_FUNCTION_REMOVE = 'SUB_MENU_ITEM_FUNCTION_REMOVE';
const SUB_MENU_ITEM_FORMAT_CLEAR = 'SUB_MENU_ITEM_FORMAT_CLEAR';
const Remove = 'Remove';
const Vertical = 'Vertical';

const MENU_ITEM_STATIC = [{
  name: 'Sort',
  type: MAIN_MENU_ITEM,
  subItems: [{
    name: 'Sort Up',
    type: SUB_MENU_ITEM
  }, {
    name: 'Sort Down',
    type: SUB_MENU_ITEM
  }, {
    name: 'Unsort',
    type: SUB_MENU_ITEM
  }]
}]

const MENU_ITEM_FUNCTION_FORMAT = [
  {
    name: 'Function',
    type: MAIN_MENU_ITEM,
    subItems: []
  }, {
    name: 'Formats',
    type: MAIN_MENU_ITEM,
    subItems: []
  }
]

const MENU_ITEM_REMOVE = [
  {
    name: Remove,
    type: MAIN_MENU_ITEM
  }
]

const CUSTOM_FORMAT = 'Custom Format';

//get grid enhancement menu items as per supported feature
function GetMenuItems(reportPart)
{
  let staticMenuItems =MENU_ITEM_STATIC.concat(MENU_ITEM_FUNCTION_FORMAT);
  if(reportPart.reportPartContent.properties.generalInfo.gridStyle==Vertical)
  {
    // As of now for ticket IZ-27401 remove option should be available only for vertical and horizontal grid
    staticMenuItems = [].concat(staticMenuItems,MENU_ITEM_REMOVE);
  }

  return staticMenuItems;
}

class ContextMenu extends React.Component {
  constructor(props) {
    super(props);
    let menuItems = (props.isPreview || props.isExploreView) ? GetMenuItems(props.reportPart): MENU_ITEM_STATIC;
    this.state = {
      menuItems: menuItems
    };
   this.existingFormatfieldDataType = null;
  }

  componentDidMount() {
    this.propertiesEditorModel = new PropertiesEditorModel();
  }


  componentDidUpdate() {
    if ( this.props.isPreview || this.props.isExploreView) {
      const { field: { querySourceId, dataFieldType }, element } = this.props.cellInfor;
     
      if (querySourceId &&  dataFieldType != this.existingFormatfieldDataType) {
        this.existingFormatfieldDataType = element.field.dataFieldType;
        this.getFunctions(querySourceId, dataFieldType, element);
        this.getFormats(querySourceId, dataFieldType, element);
      }
    }
  }

  groupByFormats = (formats,fieldDataType) => {
    var result = _(formats)
    .groupBy('category')
    .map((v, category) => ({
      name: category,
      fieldDataType : fieldDataType || null,
      subMenuLinks: _.map(v, 'name'),
      subCategory: v,
    }))
    .value();

    
    return result;
  }

  setMenuFormats = (formats, element) => {
    const { localization } = this.props;
    const categoryWiseFormats = this.groupByFormats(formats,element.field.dataFieldType);
    
    if (formats && formats.length > 0) {
      let { menuItems } = this.state;
      menuItems[2].subItems = this.groupByFormats(formats);
      if (element && element.properties && element.properties.dataFormattings && element.properties.dataFormattings.format.formatId
       ) {
        if (menuItems[2].subItems && menuItems[2].subItems.length > 0) {
          menuItems[2].subItems.splice(0, 0, {
            name: localization.getText('COMMON_LABEL_MENU_CLEAR_FORMAT'),
            type: SUB_MENU_ITEM_FORMAT_CLEAR
          });
          formats.splice(0, 0, {});
        }
      }

      this.setState({menuItems, formatterData: categoryWiseFormats});
    } else {
      let { menuItems } = this.state;
      menuItems[2].subItems = [];
      this.setState({menuItems,formatterData:[{fieldDataType:element.field.dataFieldType}]});
    }

  }

  getFunctions = (querySourceId, dataFieldType, element) => {
    const { localization } = this.props;
    if (this.props.sourceForm === 'report-part-grid-pivot') {
      let { menuItems } = this.state;
      menuItems[1].subItems = [{
        name: FUNCTION.GROUP.NAME,
        type: SUB_MENU_ITEM_FUNCTION
      }];
      return this.setState({menuItems});
    }
    let uiState = {};
    commonDataStore
      .loadReportFunction(
        FIELD_FUNCTION_MODE.FieldProperty,
        dataFieldType,
        uiState.tenantId,
        [querySourceId]
      )
      .then((data) => {
        let menuList = [], filteredMenu = [];
        if (element && element.properties && element.properties.dataFormattings
          && element.properties.dataFormattings.functionInfo.id
          && element.properties.dataFormattings.functionInfo.id.length > 0
          && element.properties.dataFormattings.functionInfo.name != FUNCTION.GROUP.NAME) {
          if (data && data.length > 0) {
            let removeItemMenu = {...data.filter(item => item.name === FUNCTION.GROUP.NAME)[0]};
            removeItemMenu.type = SUB_MENU_ITEM_FUNCTION_REMOVE;
            removeItemMenu.name = localization.getText('COMMON_LABEL_MENU_REMOVE_FUNCTION');
            menuList.push(removeItemMenu);
          }

          filteredMenu = data.filter(item => item.id !== element.properties.dataFormattings.functionInfo.id)
        } else {
          filteredMenu = data;
        }

        let subMenu = menuList.concat(filteredMenu)

        let { menuItems } = this.state;
        menuItems[1].subItems = subMenu;
        this.setState({menuItems})
      });
  }

  getFormats = (querySourceId, dataFieldTypes) => {
    const { needUpdatePreview, cellInfor, reportPart, previewRecords } = this.props;
    let { field, element } = cellInfor;
    let { reportPartContent } = reportPart;

    let dataFieldType = element && 
    element.properties && 
    element.properties.dataFormattings && element.properties.dataFormattings.functionInfo &&
     element.properties.dataFormattings.functionInfo.formatDataType? element.properties.dataFormattings.functionInfo.formatDataType: field.dataFieldType;
    let formatsData = commonDataStore.loadReportFieldDataFormat(dataFieldType).then(formats => {
      if (dataFieldType === DATA_TYPES.DATE_TIME) {
        let formatsData = DateTimeUtils.filterDateTimeFormat(formats);
        return this.setMenuFormats(formatsData, element)
      }
      if (dataFieldType === DATA_TYPES.MONEY || dataFieldType === DATA_TYPES.NUMERIC) {
        let filteredFormats = reportPartUtils.filterFormatForField(
          reportPartContent,
          formats,
          false,
          "columns"
        );
        this.setMenuFormats(filteredFormats, element);
        return filteredFormats;
      }
      this.setMenuFormats(formats, element)
      return formats;
    });

  }

  handleActionClick = (action, index,parentIndex = null) => {
    if (action.name === 'Sort Up') {
      this.handleSortReport('ASC');
      return;
    }

    if (action.name === 'Sort Down') {
      this.handleSortReport('DESC');
      return;
    }

    if (action.name === 'Unsort') {
      this.handleSortReport('');
      return;
    }
    if(action.name === Remove) {
      this.handleRemoveField();
      return;
    }

    if (action.type === SUB_MENU_ITEM_FUNCTION_REMOVE) {
       action.name = FUNCTION.GROUP.NAME;
    }

    if (action.type === SUB_MENU_ITEM_FORMAT_CLEAR) {
      const { onSetFormatterCallback, cellInfor: { element } } = this.props;
      onSetFormatterCallback({index: element.position, formatData: {
        id: null,
        format: null,
        groupBy: null
      }});
      return ;
    }

    if (action.type === 'SUB_MENU_ITEM') {
      const { onSetFormatterCallback, cellInfor: { element } } = this.props;
      const formatData = this.state.formatterData[parentIndex].subCategory[index];
      const customFormatId = { id: formatData.customId };
      const customFormatData = { ...formatData, ...customFormatId };
      const formatDataVal =  formatData.category != CUSTOM_FORMAT ? formatData : customFormatData;
      onSetFormatterCallback({index: element.position, formatData: formatDataVal});
      return ;
    }

    if (this.props.sourceForm === 'report-part-grid-pivot') {
      return ;
    }
   
    const { onSetFunctionCallback, cellInfor: { element } } = this.props;
    onSetFunctionCallback({index: element.position, functionData: action});
  }

  handleSortReport = (sortValue) => {
    const { needUpdatePreview, cellInfor, reportPart, previewRecords } = this.props;
    let { element } = cellInfor;
    element.properties.setSortValue(sortValue);
    needUpdatePreview(reportPart, null, null, null, null, previewRecords);
  }

  handleRemoveField = () => {
    const {needUpdatePreview, cellInfor, reportPart,previewRecords,isExploreView,exploreStore, reportDesignerFieldStore } = this.props;
    let { element } = cellInfor;
    if(isExploreView)
    {
      exploreStore.originalAllQuerySourceFields[0].querySource.map(item=>{
          const querySourceField = item.fields.filter(x=>x.id==element.field.fieldId)
             if(querySourceField.length>0)
             {
              exploreStore.availableAllQuerySourceFields[0].querySource.map(querySourceItem=>{
                  if(querySourceItem.id==element.field.querySourceId)
                  {
                    querySourceItem.fields.push(querySourceField[0]);
                  }
              });
             
             }
       });
       reportDesignerFieldStore.setNeedToExploreStoreReportInfoUpdate(true);
    }
    const container = reportPart.getContainerDetails(element);
    reportPart.removeFieldFromContainer(container, element);
    needUpdatePreview(reportPart);
    
  }

  getIndex(subMenuItem,index){
    if (subMenuItem.subItems[0].type === 'SUB_MENU_ITEM_FORMAT_CLEAR')
        return  index -1;
   return index;
  }

  render() {
    const {
      isVisible,
      mouseEvent
    } = this.props;

    const {
      menuItems
    } = this.state;

    const contextMenuStyle = {
      'top': mouseEvent && mouseEvent.clientY || 0,
      'left': mouseEvent && mouseEvent.clientX || 0
    };

    const isOpenClass = isVisible ? ' is-open' : '';

    return (
      <ul className={`izenda-context-menu${isOpenClass}`} style={contextMenuStyle}>
        {menuItems.map((menuItem,indexKey) => {
          return (
            <li key={indexKey} className={'main-menu-item ' + (menuItem.subItems && menuItem.subItems.length === 0 ? 'disabled' : '')}   onClick={(menuItem.name == Remove) 
            && (() => this.handleActionClick(menuItem, null))}>
              {menuItem.name}
              {menuItem.subItems && menuItem.subItems.length > 0 && (
              <div className='sub-menu-container'>
                <ul>
                  {menuItem.subItems.map((subMenuItem, index) =>
                    <li key={index} className='sub-menu-item' 
                    onClick={(menuItem.name == 'Formats') 
                    && (subMenuItem.type != 'SUB_MENU_ITEM_FORMAT_CLEAR')? '': () =>
                     this.handleActionClick(subMenuItem, index)}>
                    {subMenuItem.name}
                      {subMenuItem && subMenuItem.subMenuLinks && (
                      <div className='sub-menu-link-container'>
                        <ul>
                        {subMenuItem.subMenuLinks.map((elem, i) =>
                          <li key={i} className='sub-menu-item'
                            onClick={() => this.handleActionClick({name: `${elem}`, type: 'SUB_MENU_ITEM'}, i,this.getIndex(menuItem,index))}
                          >
                             {elem}
                          </li>
                          )}
                        </ul>
                      </div>
                      ) }
                    </li>
                    )}
                </ul>
              </div>)}
            </li>
          );
        })}
      </ul>
    );
  }
}

export default ContextMenu;


// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.ContextMenu.jsx